// extracted by mini-css-extract-plugin
module.exports = {"amenities":"amenities-9fvq-","amenities__item":"amenities__item-1LyLb","amenities__item_unavailable":"amenities__item_unavailable-3enMo"};